import { render, staticRenderFns } from "./ConfirmStudentModal.vue?vue&type=template&id=0c5086a9&"
import script from "./ConfirmStudentModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmStudentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports